<template>
  <div class="gathered-here-content">
    <div class="img credit-c" :style="'background-image: url('+ image +')'">
      <p class="credit">{{ credit }}</p>
    </div>

    <div class="txt text-center">
      <h4>Write your Will for free with</h4>
      <div class="title-logo">
        <a :href="redirectUrl">
          <img :src="ghLogo" alt="Gathered Here logo">
        </a>
      </div>
      <h5>WWF-Australia is delighted to offer you an opportunity to create your Will for free. We've partnered with <a :href="redirectUrl">Gathered Here</a>, a step-by-step online Will writing service. You can have an incredible impact on our precious wildlife and the places they call home.</h5>

      <p class="error-message text-center" v-show="isInvalid">Invalid email address.</p>

      <input
        type="email"
        class="gathered-here-email"
        :class="{'border-red': errors.has('email')}"
        name="email"
        placeholder="Enter email address"
        v-model="email"
        v-validate="'email'"
        :disabled="isSubmitting"
      >
      <p class="privacy-caption">* Any information shared is protected by our <a :href="privacyPolicyUrl">Privacy Policy.</a></p>
      <button class="bttn-lrg-arrw" @click="submit" :disabled="isSubmitting">Create my free will</button>
    </div>

    <svg v-if="showGraphic" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" xml:space="preserve">
      <path d="M9.9,18.7c0.1-0.7,0-2.5,0.7-2.9c0.5-0.4,1.2-0.2,1.4,0.1c0.4,0.3,0.3,1.8,0.6,1.8c-0.1,0.5,0.1,1.9-0.4,2.4
            c-0.3,0.5-0.8,0-1.4-0.1C10.2,19.8,9.8,19.5,9.9,18.7z M21.3,10.2c0.8-0.6,0.5-2.4,0.5-3.4c0,0-0.3-2.4-1.6-1.1
            c-0.6,0.7-1,2.4-0.8,3.3C19.4,10,20.3,10.9,21.3,10.2z M30.7,8.5c0.8-0.9,1.1-2.1,1-3.1c-0.2-0.7-0.8-2.3-1.8-1.6
            c-0.6,0.5-0.7,2.4-0.7,3.3S29.6,9.6,30.7,8.5z M39,21c1.2-0.1,1.3-1.1,1.2-2.1c0-0.8,0.2-2.9-1.2-2.6c-1.2,0.2-1.2,1.9-1.2,2.8
            S37.9,21.1,39,21z M43.1,27.4c-0.3-1.7-0.4-3.5-2-4.5c-1.4-0.9-2.9-0.5-4.2,0.2c-2.6,1.7-3.5,4.8-3.1,7.8c0.3,2.4,2.5,7.8,5.8,5.9
            c1.5-0.9,2.2-2.8,2.8-4.2C43,31,43.4,29.1,43.1,27.4z M27.2,23.9c1.1,0.8,2.3,2.2,3.7,2.2c1.2-0.1,2.3-0.6,3-1.7
            c1.4-2.1,1.7-5.5,1.6-8.1c0-2.4-1-6-3.9-6c-2.7,0-4.6,2.6-5.3,5.1c-0.6,1.4-0.7,2.9-0.4,4.4C26,21.3,25.9,23,27.2,23.9z M21.6,27.5
            c0.5-0.5,1-0.7,1.3-1.3c0.5-0.5,0.6-1.6,0.9-2.3c0.6-1.7,0.8-3.4,0.7-5.3c0.1-1.5-0.6-4-2-4.6c-0.7-0.5-1.9-0.4-2.7-0.3
            c-0.7,0-1.2,0.1-1.8,0.4c-2.8,1.7-2.8,6.4-2.3,9.5C16.3,26.2,18.6,30.4,21.6,27.5z M16,27.5c-0.1-1-0.6-2-1-2.8
            c-0.4-0.7-0.6-1.5-1.1-2c-0.5-0.5-1.7-0.2-2.4-0.2c-0.7,0-1.5-0.1-2.2,0.1c-0.8,0.4-1,1.1-1.3,1.8c-0.5,0.7-1,1.1-1.1,1.8
            c-0.1,0.7-0.1,1.7-0.2,2.6c0,0.8-0.1,1.9,0.3,2.7c0.2,0.7,0.6,1.3,1,1.8c1.1,1.1,2,1.7,3.5,2.2c0.5,0.1,1.1,0.6,1.7,0.2
            c0.5-0.2,1.3-0.8,1.6-1.3c0.3-0.7,0.1-1.2,0.2-1.5c0-0.8,0.6-1.7,0.7-2.6S16.1,28.3,16,27.5z M35,35.7c-0.9-0.8-1.6-1.3-2.2-2.4
            c-0.6-1-0.5-2.2-1-3.2c-0.4-0.8-1.6-1.6-2.5-2.1c-4-1.8-8.2,2-9,5.9c-0.1,0.9-0.2,1.9-0.9,2.6c-0.6,0.7-1.5,1.3-2.1,2
            c-1.6,2-1,3.4,0.6,5.2c1.4,1.4,3.4,3,5.6,2.6c1.2-0.2,1.8-0.8,2.6-1.5c1-0.7,1.8-0.3,2.9,0.2c1.7,0.6,3.4,1,5.1-0.3
            c2-1.3,1.8-3.8,2-5.9c-0.3-0.1-0.3-1.5-0.4-1.8C35.7,36.5,35.3,36,35,35.7z" class="st0"></path>
    </svg>
  </div>
</template>

<script>
export default {
  name: "GatheredHerePopup",

  data() {
    return {
      email: null,
      isSubmitting: false,
      isInvalid: false,
    };
  },
  props: {
    image: {
      type: String,
      default: "https://wwf-staging.wwf.org.au/ecThemes/3/Images/snow-leopard-sm.jpg",
    },
    credit: {
      type: String,
      default: "© Connie Nicolas Photography / WWF-Aus",
    },
    redirectUrl: {
      type: String,
      default: "https://wills.gatheredhere.com.au/c/wwf",
    },
    privacyPolicyUrl: {
      type: String,
      default: "https://www.wwf.org.au/privacy-policy",
    },
    showGraphic: {
      type: Boolean,
      default: true,
    },
    ghLogo: {
      type: String,
      default: "https://wwf-staging.wwf.org.au/ecThemes/3/Images/gatheredhere-logo.jpg",
    },
  },

  methods: {
    submit() {
      // Email registration is optional, just redirect if field left blank
      if (!this.email) {
        window.location.href = this.redirectUrl
        return;
      }

      this.isSubmitting = true;
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$http
            .post(wwfconfigs.WEB_API + "/bequest", {
              email: this.email,
              source: "GH pop-up",
            })
            .then((response) => {
              window.location.href = this.redirectUrl
            })
            .catch((err) => {
              this.isInvalid = true;
              this.isSubmitting = false;
              console.error(err);
            });
        } else {
          this.isInvalid = true;
          this.isSubmitting = false;
        }
      })
    }
  },
};
</script>

<style scoped>
.gathered-here-content h4 {
  margin-bottom: 10px;
}

.title-logo img {
  width: 260px;
  margin-bottom: 25px;
}

.error-message {
  font-size: 16px;
  color: var(--errorColor);
}

.gathered-here-email {
  max-width: 400px;
  margin: 10px auto;
}

.privacy-caption {
  font-size: 12px;
  margin: 10px;
}

.gathered-here-content button.bttn-lrg-arrw:hover,
.gathered-here-content button.bttn-lrg-arrw:focus {
  background-color: #F37043;
}

@media only screen and (max-width: 40em) {
  .gathered-here-content .img {
    height: 150px;
  }

  .gathered-here-content .txt {
    padding: 0 20px;
  }

  .privacy-caption {
    font-size: 10px;
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// GatheredHerePopup.vue?06ec570a